import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { usePageSeo } from "@/lib/seo";
import { faqs } from "@/data/faq";

export default function Faq() {
  usePageSeo({
    path: "/faq",
    title: "FAQ | Crisis PR & Strategic Communications | Park Communications",
    description:
      "Answers to common questions about crisis management, crisis PR, reputation management, media relations and how to hire a crisis communications consultant — from Park Communications.",
  });

  return (
    <main data-testid="faq-page">
      <Header solid linkBase="/" />

      <section className="relative bg-navy text-ivory grain overflow-hidden pt-40 pb-20">
        <div className="relative mx-auto max-w-4xl px-6">
          <Link to="/" data-testid="faq-back" className="overline text-ivory/40 hover:text-gold transition-colors">
            &larr; Back to home
          </Link>
          <p className="overline text-gold mt-10 mb-6">Frequently asked questions</p>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.03]">
            Questions, answered.
          </h1>
          <p className="text-ivory/70 text-lg leading-relaxed max-w-2xl mt-8">
            What a crisis PR firm does, how to respond when your company is in the news, what it costs, and how to hire a
            crisis communications consultant. If your question isn&apos;t here, ask us directly.
          </p>
        </div>
      </section>

      <section className="bg-ivory py-24">
        <div className="mx-auto max-w-4xl px-6">
          <div className="border-t border-navy/15">
            {faqs.map((item, i) => (
              <motion.div
                key={i}
                data-testid={`faq-item-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 6) * 0.04 }}
                className="border-b border-navy/15 py-8 grid md:grid-cols-[1fr_1.4fr] gap-4 md:gap-10"
              >
                <h2 className="font-serif font-light text-2xl sm:text-3xl leading-snug text-navy">{item.q}</h2>
                <p className="text-navy/70 leading-relaxed">{item.a}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-navy text-ivory grain relative overflow-hidden py-20">
        <div className="relative mx-auto max-w-4xl px-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-8">
          <h2 className="font-serif font-light text-3xl sm:text-4xl max-w-xl">Still have a question? Let&apos;s talk, in confidence.</h2>
          <a
            href="/#contact"
            data-testid="faq-cta"
            className="shrink-0 inline-flex items-center gap-3 bg-gold hover:bg-ivory text-navy px-8 py-4 overline transition-colors"
          >
            Start a conversation <span>&rarr;</span>
          </a>
        </div>
      </section>

      <Footer />
    </main>
  );
}
